<template>
    <v-progress-linear
            v-if="fetching"
            indeterminate
            absolute
            top
    ></v-progress-linear>
    <v-sheet
            v-else
            color="transparent"
    >
        <v-row
                class="fill-height"
                align="start"
                justify="center"
        >
            <v-col
                    lg="4"
                    sm="12"
            >
                <v-card
                        class="mx-auto"
                        max-width="400"
                >
                    <v-sheet
                            class="v-sheet--offset mx-auto"
                            elevation="12"
                            max-width="calc(100% - 32px)"
                    >
                        <vc-calendar
                                :columns="$screens({ default: 1, lg: 1 })"
                                is-expanded
                                :attributes='attrs'
                                is-
                        />
                    </v-sheet>

                    <v-card-title>
                        <v-icon
                                large
                                left
                        >
                            mdi-calendar
                        </v-icon>
                        <span class="title">Calendar</span>
                    </v-card-title>

                    <v-card-text>
                        <span>This calendar shows which day you practise deep work activities.</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                    lg="4"
                    sm="12"
            >
                <v-card
                        class="mx-auto"
                        max-width="400"
                >
                    <v-sheet
                            class="v-sheet--offset mx-auto"
                            elevation="12"
                            max-width="calc(100% - 32px)"
                    >
                        <v-sparkline
                                :labels="labels"
                                :value="value"
                                :gradient="gradient"
                                :smooth="radius || false"
                                :padding="padding"
                                :line-width="lineWidth"
                                :stroke-linecap="lineCap"
                                :gradient-direction="gradientDirection"
                                :fill="fill"
                                :type="type"
                                :auto-line-width="autoLineWidth"
                                auto-draw
                                :show-labels="showLabels"
                                :label-size="labelSize"
                        ></v-sparkline>

                    </v-sheet>

                    <v-card-title>
                        <v-icon
                                large
                                left
                        >
                            mdi-timelapse
                        </v-icon>
                        <span class="title">Overall Daily</span>
                    </v-card-title>

                    <v-card-text>
                        <span>This chart shows which hour you practise deep work activities.</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
  import { db, auth } from '../main'
  import * as moment from 'moment'
  import { store } from "../store";

  const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#f72047', '#ffd200', '#1feaea'],
  ]

  export default {
    name: "HistoryChart",
    data: () => ({
      attrs: [],
      fetching: false,
      dateFormat: 'YYYY-MM-DD',
      labels: [
        '12am',
        ' ',
        ' ',
        '3am',
        ' ',
        ' ',
        '6am',
        ' ',
        ' ',
        '9am',
        ' ',
        ' ',
        '12pm',
        ' ',
        ' ',
        '3pm',
        ' ',
        ' ',
        '6pm',
        ' ',
        ' ',
        '9pm',
        ' ',
        '11pm',
      ],
      value: [
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
      ],
      showLabels: false,
      lineWidth: 2,
      labelSize: 7,
      radius: 10,
      padding: 16,
      lineCap: 'round',
      gradient: gradients[5],
      gradientDirection: 'top',
      gradients,
      fill: false,
      type: 'trend',
      autoLineWidth: false,
    }),
    methods: {

      fetchFromFirestore: function () {
        let query = db.collection('history')
          .where('user', '==', '/users/' + auth.currentUser.uid)
          .where('year', '==', moment().year())
          .orderBy("date", "desc");

        this.fetching = true;

        query.get()
          .then(querySnapshot => {
            let data = [];

            let sum = moment.duration();
            let previousDate = null;

            querySnapshot.forEach(doc => {
              if (previousDate !== doc.get('date')) {
                if (previousDate != null) {
                  data.push({
                    highlight: this.getDotColor(sum),
                    dates: moment(previousDate).toDate(),
                    popover: {
                      label: sum.humanize()
                    }
                  });
                }

                sum = moment.duration();
                previousDate = doc.get('date');
              }

              sum.add(doc.get('seconds'), 's');

              const startTime = doc.get('start');
              console.log(startTime)
              if (startTime !== undefined) {
                this.value[moment(startTime).hour()] += doc.get('seconds');
              }

            });

            data.push({
              highlight: this.getDotColor(sum),
              dates: moment(previousDate).toDate(),
              popover: {
                label: sum.humanize()
              }
            });

            this.attrs = data;

            this.fetching = false;
          })
      },

      format: (seconds) => {
        return Math.floor(seconds / process.env.VUE_APP_POMODORO_DAILY_SUM_UNIT)
      },

      getDotColor: (duration) => {
        return 'green';
        // if (duration.get('hours') >= 2) {
        //   return 'green';
        // }
        //
        // return 'orange';
      }
    },
    mounted() {
      this.$ga.page('/track');

      auth.onAuthStateChanged(user => {
        console.log(user)
        if (user)
          this.fetchFromFirestore()
      });
    }
  }
</script>

<style>
    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    @media only screen and (max-width: 600px) {
        .v-sheet--offset {
            margin-top: 12px
        }
    }
</style>
